export default __webpack_public_path__ + "../staticImages/katalog-260.png";